module.exports = __webpack_public_path__ + "img/cursive-workbook_B09917X1GV.7985c03f.jpg";